import { render, staticRenderFns } from "./SqlModal.vue?vue&type=template&id=84c4ab40&scoped=true"
import script from "./SqlModal.vue?vue&type=script&lang=js"
export * from "./SqlModal.vue?vue&type=script&lang=js"
import style0 from "./SqlModal.vue?vue&type=style&index=0&id=84c4ab40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c4ab40",
  null
  
)

export default component.exports